export enum LoanMoodysRating {
    Aaa = 'Aaa',
    Aa1 = 'Aa1',
    Aa2 = 'Aa2',
    Aa3 = 'Aa3',
    A1 = 'A1',
    A2 = 'A2',
    A3 = 'A3',
    Baa1 = 'Baa1',
    Baa2 = 'Baa2',
    Baa3 = 'Baa3',
    Ba1 = 'Ba1',
    Ba2 = 'Ba2',
    Ba3 = 'Ba3',
    B1 = 'B1',
    B2 = 'B2',
    B3 = 'B3',
    Caa1 = 'Caa1',
    Caa2 = 'Caa2',
    Caa3 = 'Caa3',
    Ca = 'Ca',
    C = 'C',
    NR = 'NR'
}

export enum LoanSnpRating {
    AAA = 'AAA',
    AAPlus = 'AAPlus',
    AA = 'AA',
    AAMinus = 'AAMinus',
    APlus = 'APlus',
    A = 'A',
    AMinus = 'AMinus',
    BBBPlus = 'BBBPlus',
    BBB = 'BBB',
    BBBMinus = 'BBBMinus',
    BBPlus = 'BBPlus',
    BB = 'BB',
    BBMinus = 'BBMinus',
    BPlus = 'BPlus',
    B = 'B',
    BMinus = 'BMinus',
    CCCPlus = 'CCCPlus',
    CCC = 'CCC',
    CCCMinus = 'CCCMinus',
    CC = 'CC',
    C = 'C',
    D = 'D',
    NR = 'NR'
}

export enum LoanFitchRating {
    AAA = 'AAA',
    AAPlus = 'AAPlus',
    AA = 'AA',
    AAMinus = 'AAMinus',
    APlus = 'APlus',
    A = 'A',
    AMinus = 'AMinus',
    BBBPlus = 'BBBPlus',
    BBB = 'BBB',
    BBBMinus = 'BBBMinus',
    BBPlus = 'BBPlus',
    BB = 'BB',
    BBMinus = 'BBMinus',
    BPlus = 'BPlus',
    B = 'B',
    BMinus = 'BMinus',
    CCC = 'CCC',
    DDD = 'DDD',
    DD = 'DD',
    D = 'D',
    NR = 'NR'
}

export const loanMoodysRatingTitles: Record<LoanMoodysRating, string> = {
    [LoanMoodysRating.Aaa]: 'Aaa',
    [LoanMoodysRating.Aa1]: 'Aa1',
    [LoanMoodysRating.Aa2]: 'Aa2',
    [LoanMoodysRating.Aa3]: 'Aa3',
    [LoanMoodysRating.A1]: 'A1',
    [LoanMoodysRating.A2]: 'A2',
    [LoanMoodysRating.A3]: 'A3',
    [LoanMoodysRating.Baa1]: 'Baa1',
    [LoanMoodysRating.Baa2]: 'Baa2',
    [LoanMoodysRating.Baa3]: 'Baa3',
    [LoanMoodysRating.Ba1]: 'Ba1',
    [LoanMoodysRating.Ba2]: 'Ba2',
    [LoanMoodysRating.Ba3]: 'Ba3',
    [LoanMoodysRating.B1]: 'B1',
    [LoanMoodysRating.B2]: 'B2',
    [LoanMoodysRating.B3]: 'B3',
    [LoanMoodysRating.Caa1]: 'Caa1',
    [LoanMoodysRating.Caa2]: 'Caa2',
    [LoanMoodysRating.Caa3]: 'Caa3',
    [LoanMoodysRating.Ca]: 'Ca',
    [LoanMoodysRating.C]: 'C',
    [LoanMoodysRating.NR]: 'NR',
};

export const loanSnpRatingTitles: Record<LoanSnpRating, string> = {
    [LoanSnpRating.AAA]: 'AAA',
    [LoanSnpRating.AAPlus]: 'AA+',
    [LoanSnpRating.AA]: 'AA',
    [LoanSnpRating.AAMinus]: 'AA-',
    [LoanSnpRating.APlus]: 'A+',
    [LoanSnpRating.A]: 'A',
    [LoanSnpRating.AMinus]: 'A-',
    [LoanSnpRating.BBBPlus]: 'BBB+',
    [LoanSnpRating.BBB]: 'BBB',
    [LoanSnpRating.BBBMinus]: 'BBB-',
    [LoanSnpRating.BBPlus]: 'BB+',
    [LoanSnpRating.BB]: 'BB',
    [LoanSnpRating.BBMinus]: 'BB-',
    [LoanSnpRating.BPlus]: 'B+',
    [LoanSnpRating.B]: 'B',
    [LoanSnpRating.BMinus]: 'B-',
    [LoanSnpRating.CCCPlus]: 'CCC+',
    [LoanSnpRating.CCC]: 'CCC',
    [LoanSnpRating.CCCMinus]: 'CCC-',
    [LoanSnpRating.CC]: 'CC',
    [LoanSnpRating.C]: 'C',
    [LoanSnpRating.D]: 'D',
    [LoanSnpRating.NR]: 'NR',
};

export const loanFitchRatingTitles: Record<LoanFitchRating, string> = {
    [LoanFitchRating.AAA]: 'AAA',
    [LoanFitchRating.AAPlus]: 'AA+',
    [LoanFitchRating.AA]: 'AA',
    [LoanFitchRating.AAMinus]: 'AA-',
    [LoanFitchRating.APlus]: 'A+',
    [LoanFitchRating.A]: 'A',
    [LoanFitchRating.AMinus]: 'A-',
    [LoanFitchRating.BBBPlus]: 'BBB+',
    [LoanFitchRating.BBB]: 'BBB',
    [LoanFitchRating.BBBMinus]: 'BBB-',
    [LoanFitchRating.BBPlus]: 'BB+',
    [LoanFitchRating.BB]: 'BB',
    [LoanFitchRating.BBMinus]: 'BB-',
    [LoanFitchRating.BPlus]: 'B+',
    [LoanFitchRating.B]: 'B',
    [LoanFitchRating.BMinus]: 'B-',
    [LoanFitchRating.CCC]: 'CCC',
    [LoanFitchRating.DDD]: 'DDD',
    [LoanFitchRating.DD]: 'DD',
    [LoanFitchRating.D]: 'D',
    [LoanFitchRating.NR]: 'NR',
};
